export const API_URI = 'https://tri-back-production.up.railway.app'
// export const API_URI = 'http://localhost:4000'